<section class="group-list" *appHasPermission="groupPermissions.MODULE">
  <div class="group-list__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
    <div class="group-list__header__map">
      <i class="pi pi-map d-none"></i>
    </div>
  </div>
  <div class="group-list__header">
    <div class="group-list__header__title">
      <h1 class="mb-0 mb-md-2">{{ tk.General.Groups | t }}</h1>
    </div>
    <div class="group-list__header__search">
      <div class="form-search me-3 d-none d-md-flex">
        <app-search
          [isLoading]="isLoading"
          [placeholder]="(tk.General.Search | t) || ''"
          (sendSearch)="handleSearch($event)"></app-search>
      </div>
      <ng-container *appHasPermission="groupPermissions.CREATE">
        <app-button
          *ngIf="permissionGroups.length"
          [id]="'add-group'"
          [label]="isMobile ? '' : (tk.User.ToAdd | t)"
          [icon]="'pi pi-plus'"
          [type]="'button'"
          (sendButtonClick)="addGroup()"></app-button>
      </ng-container>
    </div>
  </div>
  <div class="group-list__content">
    <app-group-list-content
      [groupList]="permissionGroups"
      [pagination]="pagination"
      [loading]="loading"
      (sendTablePagination)="handleTablePagination($event)"
      (sendTableAction)="handleTableAction($event)"></app-group-list-content>
  </div>
</section>
